import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createUser, logOutUser } from "../actions/postAction";

import axios from "axios";
import { BASE_URL } from "../constant";
import Swal from "sweetalert2";
import { NetworkError } from "./NetworkError";
import { Loading } from "./Loading";

import moment from "moment";
import "moment-timezone";

import Select from "react-select";
import {endpoints, http} from "../configs/https";
const selectStyles = {
  menu: base => ({
    ...base,
    zIndex: 100
  })
};

class SubmitedReports extends Component {
  constructor() {
    super();
    var d = new Date();
    var n = d.getFullYear();
    var m = d.getMonth() + 1;
    this.state = {
      tajneed: {},
      atfal: false,
      etemad: false,
      tabligh: false,
      audit: false,
      ishaat: false,
      maal: false,
      taleem: {},
      labour: {},
      general: false,
      health: false,
      new_convert: false,
      social: false,
      student: false,
      tahrik: false,
      tarbiyya: false,
      trade: false,
      networkError: false,
      isLoading: false,
      month: { label: moment().format("MMMM"), value: m },
      value: { label: n, value: n }
    };

    this.checkStatus = this.checkStatus.bind(this);
  }
  options = [
    { label: 2021, value: 2021 },
    { label: 2020, value: 2020 },
    { label: 2019, value: 2019 },
    { label: 2018, value: 2018 },
    { label: 2017, value: 2017 },
    { label: 2016, value: 2016 },
    { label: 2015, value: 2015 },
    { label: 2014, value: 2014 },
    { label: 2013, value: 2013 },
    { label: 2012, value: 2012 },
    { label: 2011, value: 2011 },
    { label: 2010, value: 2010 },
    { label: 2009, value: 2009 },
    { label: 2008, value: 2008 },
    { label: 2007, value: 2007 },
    { label: 2006, value: 2006 },
    { label: 2005, value: 2005 },
    { label: 2004, value: 2004 },
    { label: 2003, value: 2003 },
    { label: 2002, value: 2002 },
    { label: 2001, value: 2001 },
    { label: 2000, value: 2000 }
  ];

  months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 }
  ];

  componentDidMount() {
    document.title = "Reports - MKAN REPORT";
    this.checkStatus(this.state.month.value, this.state.value.value);
    console.log(this.state.month);
  }
  handleChangeYear(value) {
    this.setState({ value: value });
    this.checkStatus(this.state.month.value, value.value);
  }

  handleChangeMonth(value) {
    this.setState({ month: value });

    this.checkStatus(value.value, this.state.value.value);
  }
  checkStatus(month, year) {
    this.setState({
      isLoading: true,
      networkError: false,
    });
    http
      .post(
        endpoints.SUBMITTED_REPORTS,
        {
          month: month,
          year: year
        },
      )
      .then(res => {
        //    if(res.status == 201){
        this.setState({
          tabligh: res.data.tabligh,
          tajneed: res.data.tajnid,
          etemad: res.data.secretariat,
          atfal: res.data.atfal,
          audit: res.data.audit,
          ishaat: res.data.ishaat,
          maal: res.data.maal,
          taleem: res.data.taleem,
          labour: res.data.labour,
          general: res.data.general,
          health: res.data.health,
          new_convert: res.data.new_convert,
          social: res.data.social,
          student: res.data.student,
          tahrik: res.data.tahrik,
          tarbiyya: res.data.tarbiyya,
          trade: res.data.trade
        });

        this.setState({
          isLoading: false
        });

        //    }
      })
        .catch(error => {
          this.setState({
            isLoading: false,
            networkError: true,
          });
          let errorMessage =
              (typeof error === "string" && error) ||
              "An error occured, please try again in a moment.";

          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          });

          Toast.fire({
            type: "error",
            title: errorMessage
          });
          // alert(JSON.stringify(error));
          console.log(errorMessage);
        });
  }
  render() {
    return (
      <section className="content">
        {this.state.networkError ? (
          <NetworkError />
        ) : (
          <div>
            <center>
              <div className="col-md-12">
                <h4 className="title">Select Year and Month below</h4>
                <div className="row">
                  <div className="col-lg-5 col-md-6 col-sm-3 m-3 zin">
                    <div className="">
                      <Select
                        styles={selectStyles}
                        options={this.options}
                        value={this.state.value}
                        onChange={value => this.handleChangeYear(value)}
                        defaultValue={{ label: 2002, value: 2002 }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-6 col-sm-3 m-3 zin2">
                    <div className="dropdown bootstrap-select dropup">
                      <Select
                        styles={selectStyles}
                        options={this.months}
                        value={this.state.month}
                        onChange={value => this.handleChangeMonth(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </center>
            <div className="row ">
              {this.state.isLoading ? (
                <div className="text-center container">
                  <center>
                    <Loading />
                  </center>
                </div>
              ) : (
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">
                        Reports for {this.state.month.label}{" "}
                        {this.state.value.label}
                      </h4>
                    </div>
                    <div className="card-body">
                      <div id="accordion" role="tablist">
                        <div className="card-collapse">
                          <div
                            className="card-header"
                            role="tab"
                            id="headingOne"
                          >
                            <h5 className="mb-0">
                              <a
                                data-toggle="collapse"
                                href="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                className=""
                              >
                                TAJNEED
                                <i className="material-icons">
                                  keyboard_arrow_down
                                </i>
                              </a>
                            </h5>
                          </div>
                          <div
                            id="collapseOne"
                            className="collapse show"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div className="card-body">
                              {this.state.tajneed === null ? (
                                <div className="text-center">
                                  <h2>No Report found</h2>
                                </div>
                              ) : (
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.tajneed.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>Total Number of Khuddam</td>
                                      <td>{this.state.tajneed.total_khudam}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Total Number of Khuddam at 40</td>
                                      <td>{this.state.tajneed.khudam_at_40}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        Total Number of Khuddam with Uniform
                                      </td>
                                      <td>
                                        {this.state.tajneed.total_with_uniform}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>Total Number of Atfal</td>
                                      <td>{this.state.tajneed.total_atfal}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>Nazim Tajneed's Phone Number</td>
                                      <td>{this.state.tajneed.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-collapse">
                        <div className="card-header" role="tab" id="headingTwo">
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              TALEEM
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingTwo"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.taleem === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.taleem.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        Total number of Taleem classes conducted
                                        in the month
                                      </td>
                                      <td>
                                        {this.state.taleem.t_number_classes}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>
                                        {" "}
                                        No of Khuddam who participated in
                                        Talimul Quran session
                                      </td>
                                      <td>{this.state.taleem.session}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        {" "}
                                        No of Khuddam who participated in Age
                                        Group Book Review
                                      </td>
                                      <td>{this.state.taleem.book_review}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        No of Khuddam who participated in ICT
                                        training
                                      </td>
                                      <td>{this.state.taleem.ict}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>
                                        {" "}
                                        No of Khuddam who participated in
                                        proficiency exam preparation
                                      </td>
                                      <td>{this.state.taleem.exam_prep}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>Total</td>
                                      <td>{this.state.taleem.total}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>
                                        No of books reviewed during this month
                                      </td>
                                      <td>{this.state.taleem.reviewed}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>Nazim Taleem's Phone Number</td>
                                      <td>{this.state.taleem.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-collapse">
                        <div className="card-header" role="tab" id="headingTwo">
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseTabligh"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              TABLIGH
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseTabligh"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingTwo"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.tabligh === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.tabligh.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        Media Distributed (Cassette, CD, DVD)
                                      </td>
                                      <td>{this.state.tabligh.media}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td> Question and Answer Sessions</td>
                                      <td>{this.state.tabligh.question}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td> Public Lectures in the month</td>
                                      <td>{this.state.tabligh.public}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>House to house preaching</td>
                                      <td>{this.state.tabligh.house}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td> Literature Books Distributed</td>
                                      <td>{this.state.tabligh.literature}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>Tabligh Meetings</td>
                                      <td>{this.state.tabligh.tabligh}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>Letters on Tabligh in the month</td>
                                      <td>{this.state.tabligh.letters}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td> Book Stall</td>
                                      <td>{this.state.tabligh.book}</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td> Tabligh SMS/Emails</td>
                                      <td>{this.state.tabligh.tab_sms}</td>
                                    </tr>
                                    <tr>
                                      <td>11</td>
                                      <td> Number of Bai'ats</td>
                                      <td>{this.state.tabligh.n_baiat}</td>
                                    </tr>
                                    <tr>
                                      <td>12</td>
                                      <td>
                                        {" "}
                                        No of Tabligh programmes organized in
                                        the month
                                      </td>
                                      <td>{this.state.tabligh.n_tabligh}</td>
                                    </tr>
                                    <tr>
                                      <td>13</td>
                                      <td> No participating Khuddam</td>
                                      <td>{this.state.tabligh.participants}</td>
                                    </tr>
                                    <tr>
                                      <td>14</td>
                                      <td> Duration</td>
                                      <td>{this.state.tabligh.duration}</td>
                                    </tr>
                                    <tr>
                                      <td>15</td>
                                      <td>
                                        {" "}
                                        How many classes were conducted for the
                                        tabligh team this month?
                                      </td>
                                      <td>{this.state.tabligh.classes}</td>
                                    </tr>
                                    <tr>
                                      <td>16</td>
                                      <td> Attendance</td>
                                      <td>{this.state.tabligh.attendance}</td>
                                    </tr>

                                    <tr>
                                      <td>17</td>
                                      <td>Nazim Tabligh's Phone Number</td>
                                      <td>{this.state.tabligh.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                            >
                              TARBIYYA
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseThree"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.tarbiyya === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>
                                        {this.state.tarbiyya.submitted_by}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        No of Tarbiyyah Programs conducted
                                      </td>
                                      <td>
                                        {
                                          this.state.tarbiyya
                                            .no_tarbiyya_program
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Attendance</td>
                                      <td>{this.state.tarbiyya.attendance}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        No of Khuddam who observe
                                        Congregrational Prayer in Mosque
                                      </td>
                                      <td>{this.state.tarbiyya.prayer}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        No of Khuddam who write letter to huzur
                                      </td>
                                      <td>{this.state.tarbiyya.letter}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>
                                        No of Khuddam who watch MTA reagularly
                                      </td>
                                      <td>{this.state.tarbiyya.mta}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        {" "}
                                        No of Khuddam who are regular in
                                        Tahajjud prayers
                                      </td>
                                      <td>{this.state.tarbiyya.tahjud}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>
                                        {" "}
                                        No of Khuddam who are regular in 5 daily
                                        prayers
                                      </td>
                                      <td>
                                        {this.state.tarbiyya.daily_prayer}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>
                                        {" "}
                                        No of Khuddam who engaged in voluntary
                                        fast
                                      </td>
                                      <td>{this.state.tarbiyya.fast}</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>
                                        No of Khuddam who read Condition of
                                        Baiat
                                      </td>
                                      <td>{this.state.tarbiyya.bait}</td>
                                    </tr>

                                    <tr>
                                      <td>11</td>
                                      <td>Nazim Tarbiyya's Phone Number</td>
                                      <td>{this.state.tarbiyya.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseEteemad"
                              aria-expanded="false"
                              aria-controls="collapseEteemad"
                            >
                              A'ITMAD
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseEteemad"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.etemad === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>
                                  {/* "exec_meeting": true, "freq": 5,
                                  "office_bearer": 4, "present": 5,
                                  "submission": false, "qaidat_sec": false,
                                  "mulk_total": 10, "mulk_present": 14,
                                  "mulk_absent": 14, "phone": "1234567" */}
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.etemad.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        Were the Executive Committee Meetings
                                        conducted during the month?
                                      </td>
                                      <td>
                                        {this.state.etemad.exec_meeting
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>How many?</td>
                                      <td>{this.state.etemad.freq}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        Total Number of Office–bearer Present
                                      </td>
                                      <td>{this.state.etemad.office_bearer}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        Whether previous report for last month
                                        was submitted
                                      </td>
                                      <td>
                                        {this.state.etemad.submission
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>Do you have Qaida'at Secretary?</td>
                                      <td>
                                        {" "}
                                        {this.state.etemad.qaidat_sec
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        {" "}
                                        Number of Mulk Members in the Qaidat
                                      </td>
                                      <td>{this.state.etemad.mulk_total}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td> No Present at meeting</td>
                                      <td>{this.state.etemad.mulk_present}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td> No Absent</td>
                                      <td>{this.state.etemad.mulk_absent}</td>
                                    </tr>

                                    <tr>
                                      <td>10</td>
                                      <td>Motamad's Phone Number</td>
                                      <td>{this.state.etemad.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseNew"
                              aria-expanded="false"
                              aria-controls="collapseNew"
                            >
                              NOU - MUBAIYEEN
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseNew"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.new_convert === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>
                                        {this.state.new_convert.submitted_by}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        Number of Nau-Mubaiyeen Khuddam
                                        participating in Tarbiyyati class this
                                        month
                                      </td>
                                      <td>
                                        {this.state.new_convert.naumubayin}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Attendance</td>
                                      <td>
                                        {this.state.new_convert.attendance}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        Number of Nau-Mubaiyeen Majlis
                                        Tarbiyyati Camp was organised this month
                                      </td>
                                      <td>
                                        {this.state.new_convert.tarbiyyati}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        No. of Nau-Mubaiyeen Khuddam who
                                        listened to Live Friday Sermon of Huzoor
                                        this month
                                      </td>
                                      <td>{this.state.new_convert.sermon}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>
                                        No. of Nau-Mubaiyeen Khuddam who wrote
                                        letters to Huzoor for prayer this month
                                      </td>
                                      <td> {this.state.new_convert.huzur}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        No. of Nau-Mubaiyeen who observe 5 daily
                                        prayers
                                      </td>
                                      <td>{this.state.new_convert.salat}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>
                                        No. of Nau-Mubaiyeen who recite the Holy
                                        Quran
                                      </td>
                                      <td>{this.state.new_convert.quran}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>
                                        {" "}
                                        No. of Nau-Mubaiyeen Khuddam who have
                                        become Daiee illallah this month
                                      </td>
                                      <td>{this.state.new_convert.daiee}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseUmoor"
                              aria-expanded="false"
                              aria-controls="collapseUmoor"
                            >
                              UMOOR E TULABA
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseUmoor"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingUmoor"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.student === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.student.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        No of Meeting conducted this month
                                        emphasising the importance and benefits
                                        of education
                                      </td>
                                      <td>{this.state.student.meetings}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Attendance</td>
                                      <td>{this.state.student.attendance}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        No of free coaching class organised
                                      </td>
                                      <td>{this.state.student.coaching}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        No of Career counselling / Planning
                                        sessions in your Majlis to guide
                                        students
                                      </td>
                                      <td>{this.state.student.career}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>
                                        No of Students provided counselling
                                      </td>
                                      <td> {this.state.student.student}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        No. of Career counselling guidance
                                        articles published in the periodicals of
                                        Jama’at by your Majlis
                                      </td>
                                      <td>{this.state.student.periodicals}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>
                                        Endeavours done to improve the religious
                                        and moral standard of Khuddam, and to
                                        consolidate their religions and
                                        relationship with Jama’at
                                      </td>
                                      <td>
                                        <p>{this.state.student.standard}</p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>
                                        {" "}
                                        Nazim Umoor Tulaba's phone number
                                      </td>
                                      <td>{this.state.student.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseAmal"
                              aria-expanded="false"
                              aria-controls="collapseAmal"
                            >
                              WAQAR E AMAL
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseAmal"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingUmoor"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.labour === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.labour.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>Number of Waqar-e-Amal Events</td>
                                      <td>{this.state.labour.event}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Type of events</td>
                                      <td>{this.state.labour.type}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>Attendance</td>
                                      <td>{this.state.labour.attendance}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        External Waqar-e-Amal during the year
                                      </td>
                                      <td>{this.state.labour.external}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>Attachment</td>
                                      <td>
                                        {" "}
                                        {this.state.labour.attachment === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>7</td>
                                      <td>
                                        {" "}
                                        Nazim Waqar e Amal's phone number
                                      </td>
                                      <td>{this.state.labour.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseAtfal"
                              aria-expanded="false"
                              aria-controls="collapseAtfal"
                            >
                              ATFAL
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseAtfal"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingUmoor"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.atfal === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.atfal.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td> No. of Atfals</td>
                                      <td>{this.state.atfal.atfal}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>
                                        {" "}
                                        No. of Atfal sessions held in the month
                                      </td>
                                      <td>{this.state.atfal.session}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        {" "}
                                        Is Atfal organisation duly established?
                                      </td>
                                      <td>
                                        {this.state.atfal.organised
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>
                                        If Atfal organisation is not established
                                        , state reasons thereof and also mention
                                        what efforts have been done in this
                                        regard
                                      </td>
                                      <td>{this.state.atfal.establish}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>No. of Organized Camp</td>
                                      <td>{this.state.atfal.no_camp}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>No. of Atfal Present</td>
                                      <td>{this.state.atfal.no_atfal}</td>
                                    </tr>

                                    <tr>
                                      <td>8</td>
                                      <td>No. of Khuddam Present</td>
                                      <td>{this.state.atfal.no_khudam}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>Attachment (Atfal Report)</td>
                                      <td>
                                        {this.state.atfal.attachment === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td> Nazim Atfal's phone number</td>
                                      <td>{this.state.atfal.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseMaal"
                              aria-expanded="false"
                              aria-controls="collapseAtfal"
                            >
                              MAAL
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseMaal"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingUmoor"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.maal === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.maal.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td> Annual Budget</td>
                                      <td>{this.state.maal.annual_budget}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>
                                        Were there any awareness program on Maal
                                        observed?
                                      </td>
                                      <td>
                                        {this.state.maal.awareness
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td> Chanda</td>
                                      <td>{this.state.maal.chanda}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td>Operation 220</td>
                                      <td>{this.state.maal.op_220}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td> Tahrik - e - jadid</td>
                                      <td>{this.state.maal.tahrik}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td> Review of religion</td>
                                      <td>{this.state.maal.review}</td>
                                    </tr>

                                    <tr>
                                      <td>8</td>
                                      <td> Ijtema</td>
                                      <td>{this.state.maal.ijtema}</td>
                                    </tr>

                                    <tr>
                                      <td>9</td>
                                      <td> Others</td>
                                      <td>{this.state.maal.other}</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>
                                        {" "}
                                        Has detailed Maal report been attached
                                        to this report ?
                                      </td>
                                      <td>
                                        {this.state.maal.details_att
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>11</td>
                                      <td>Attachment (Maal Report)</td>
                                      <td>
                                        {this.state.maal.attachment === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>12</td>
                                      <td> Nazim Maal's phone number</td>
                                      <td>{this.state.maal.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingThree"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseTahrik"
                              aria-expanded="false"
                              aria-controls="collapseTahrik"
                            >
                              TAHRIK JADID
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseTahrik"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingUmoor"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.tahrik === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.tahrik.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td> Number of Khuddam Contribution</td>
                                      <td>
                                        {
                                          this.state.tahrik
                                            .no_khudam_contribution
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>Collection of tahrik</td>
                                      <td>
                                        {this.state.tahrik.collection_tahrik}
                                      </td>
                                    </tr>
                                    {/* <tr>
                                      <td>4</td>
                                      <td> Update on magazine</td>
                                      <td>{this.state.tahrik.chanda}</td>
                                    </tr>
                                    <tr>
                                      <td>5</td>
                                      <td> Update on review of religion</td>
                                      <td>{this.state.tahrik.op_220}</td>
                                    </tr> */}

                                    <tr>
                                      <td>4</td>
                                      <td> Nazim's phone number</td>
                                      <td>{this.state.tahrik.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingAudit"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseAudit"
                              aria-expanded="false"
                              aria-controls="collapseTahrik"
                            >
                              MUHASIB
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseAudit"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingAudit"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.audit === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.audit.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        {" "}
                                        Was income and expenditure accounts
                                        audited this month?
                                      </td>
                                      <td>
                                        {this.state.audit.income ? "Yes" : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>
                                        {" "}
                                        Was a copy of the Quarterly Audit Report
                                        sent to National Office?
                                      </td>
                                      <td>
                                        {this.state.audit.quarterly
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        {" "}
                                        Was a Day-book and Ledgers prescribed by
                                        National Office being maintained in your
                                        majlis?
                                      </td>
                                      <td>
                                        {this.state.audit.ledgers
                                          ? "Yes"
                                          : "No"}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>5</td>
                                      <td> Nazim Muhasib's phone number</td>
                                      <td> {this.state.audit.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingHealth"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseHealth"
                              aria-expanded="false"
                              aria-controls="collapseTahrik"
                            >
                              SEH'HAT -E- JISMANI
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseHealth"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingHealth"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.health === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.health.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        {" "}
                                        Was any Sport Tournament organised this
                                        month?
                                      </td>
                                      <td>
                                        {this.state.health.sport ? "Yes" : "No"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td> No of such matches</td>
                                      <td>{this.state.health.matches}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td> No of tournaments</td>
                                      <td>{this.state.health.matches2}</td>
                                    </tr>

                                    <tr>
                                      <td>5</td>
                                      <td> List of individual tournaments</td>
                                      <td> {this.state.health.individual}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td> No. of participants</td>
                                      <td> {this.state.health.participants}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td> No of health talk </td>
                                      <td> {this.state.health.health_talk}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td> No of screening </td>
                                      <td> {this.state.health.screening}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td> No. of participating Khuddam</td>
                                      <td> {this.state.health.particip_k}</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td> No. of beneficiaries</td>
                                      <td>
                                        {" "}
                                        {this.state.health.beneficiaries}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingTrade"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseTrade"
                              aria-expanded="false"
                              aria-controls="collapseTrade"
                            >
                              SANAT-O-TIJARAT
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseTrade"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingTrade"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.trade === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.trade.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>No. of unemployed Khuddam</td>
                                      <td>{this.state.trade.employed}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>
                                        {" "}
                                        No of Khuddam provided employment during
                                        the month
                                      </td>
                                      <td>
                                        {this.state.trade.employed_during}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        {" "}
                                        Attach list of the newly employed to
                                        National office
                                      </td>
                                      <td>
                                        {this.state.trade.attachment1 === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>5</td>
                                      <td> No. of unskilled Khuddam</td>
                                      <td> {this.state.trade.unskilled}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>
                                        {" "}
                                        No. Khuddam being trained in a
                                        particular skill
                                      </td>
                                      <td> {this.state.trade.training}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        {" "}
                                        Attach list of khuddam trained in
                                        particular skill{" "}
                                      </td>
                                      <td>
                                        {" "}
                                        {this.state.trade.attachment2 === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>
                                        {" "}
                                        Professions / skills in which khuddam
                                        are experts{" "}
                                      </td>
                                      <td> {this.state.trade.professions}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>
                                        {" "}
                                        Attach full details of profession /
                                        skill which khuddam are expert
                                      </td>
                                      <td>
                                        {" "}
                                        {this.state.trade.attachment3 === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td> No. of motivational talk</td>
                                      <td> {this.state.trade.motivation}</td>
                                    </tr>
                                    <tr>
                                      <td>11</td>
                                      <td> No. of Participant</td>
                                      <td> {this.state.trade.participants}</td>
                                    </tr>

                                    <tr>
                                      <td>11</td>
                                      <td> Nazim Sanat-o-Tijarat's Phone</td>
                                      <td> {this.state.trade.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingPublications"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapsePublications"
                              aria-expanded="false"
                              aria-controls="collapsePublications"
                            >
                              ISHAAT
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapsePublications"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingPublications"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.ishaat === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.ishaat.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        No. of Khuddam subscribers of the
                                        following periodicals / journals in your
                                        Majlis (The Truth)
                                      </td>
                                      <td>{this.state.ishaat.truth}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td>
                                        {" "}
                                        No. of Khuddam subscribers of the
                                        following periodicals / journals in your
                                        Majlis (Review of Religion)
                                      </td>
                                      <td>{this.state.ishaat.review}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        {" "}
                                        No. of Khuddam subscribers of the
                                        following periodicals / journals in your
                                        Majlis (Al Irfan)
                                      </td>
                                      <td>{this.state.ishaat.irfan}</td>
                                    </tr>

                                    <tr>
                                      <td>5</td>
                                      <td>
                                        {" "}
                                        No. of Khuddam subscribers of the
                                        following periodicals / journals in your
                                        Majlis (Jamaat Websites)
                                      </td>
                                      <td> {this.state.ishaat.websites}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>
                                        {" "}
                                        Any extra ordinary work in publication
                                        during the month
                                      </td>
                                      <td> {this.state.ishaat.extra_work}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        {" "}
                                        No. of Khuddam who contributed during
                                        the months towards issuing Jamaat
                                        periodicals for Tabligh purpose
                                      </td>
                                      <td> {this.state.ishaat.periodicals}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>News item about your Qaidaat</td>
                                      <td> {this.state.ishaat.news_items}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>
                                        {" "}
                                        Attachment (Copies of publications in
                                        the month)
                                      </td>
                                      <td>
                                        {" "}
                                        {this.state.ishaat.attachment === ""
                                          ? "None"
                                          : "Submitted"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td> Nazim Ishaat's Phone Number</td>
                                      <td> {this.state.ishaat.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingSocial"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseSocial"
                              aria-expanded="false"
                              aria-controls="collapseSocial"
                            >
                              KHIDMATE E KHALQ
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseSocial"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingSocial"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.social === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.social.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>
                                        No. of Khuddam involved in Rishtanata
                                        activities
                                      </td>
                                      <td>{this.state.social.rishtanata}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td> No. of widows</td>
                                      <td>{this.state.social.widows}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td>
                                        {" "}
                                        No. of unmarried khuddam (from ages 24)
                                      </td>
                                      <td>{this.state.social.unmarried}</td>
                                    </tr>

                                    <tr>
                                      <td>5</td>
                                      <td> First Aid</td>
                                      <td> {this.state.social.first_aid}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td> Medical Camp</td>
                                      <td> {this.state.social.medical_camp}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td> Blood donation</td>
                                      <td> {this.state.social.b_donation}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>Visit to elders</td>
                                      <td> {this.state.social.elder}</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td> Visit to Orphanage</td>
                                      <td>{this.state.social.orphan}</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>Visit to clinics/hospitals</td>
                                      <td> {this.state.social.clinics}</td>
                                    </tr>

                                    <tr>
                                      <td>11</td>
                                      <td>Visit to Khuddam</td>
                                      <td> {this.state.social.khudam}</td>
                                    </tr>

                                    <tr>
                                      <td>12</td>
                                      <td>
                                        How many meetings on importance of
                                        Physical Hygiene
                                      </td>
                                      <td> {this.state.social.hygiene}</td>
                                    </tr>

                                    <tr>
                                      <td>13</td>
                                      <td>Aqiqah</td>
                                      <td> {this.state.social.aqiqah}</td>
                                    </tr>

                                    <tr>
                                      <td>14</td>
                                      <td>Nikkah</td>
                                      <td> {this.state.social.nikah}</td>
                                    </tr>

                                    <tr>
                                      <td>15</td>
                                      <td>Janaza</td>
                                      <td> {this.state.social.janaza}</td>
                                    </tr>

                                    <tr>
                                      <td>16</td>
                                      <td>Walimot/Aminu Quran</td>
                                      <td> {this.state.social.walimot}</td>
                                    </tr>

                                    <tr>
                                      <td>17</td>
                                      <td>House warming</td>
                                      <td> {this.state.social.house}</td>
                                    </tr>

                                    <tr>
                                      <td>18</td>
                                      <td>Car warming</td>
                                      <td> {this.state.social.car}</td>
                                    </tr>

                                    <tr>
                                      <td>19</td>
                                      <td>No of khuddam on duty</td>
                                      <td> {this.state.social.on_duty}</td>
                                    </tr>

                                    <tr>
                                      <td>20</td>
                                      <td>
                                        Nazim Khidmat Khalq's phone number
                                      </td>
                                      <td> {this.state.social.phone}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-collapse">
                        <div
                          className="card-header"
                          role="tab"
                          id="headingGeneral"
                        >
                          <h5 className="mb-0">
                            <a
                              className="collapsed"
                              data-toggle="collapse"
                              href="#collapseGeneral"
                              aria-expanded="false"
                              aria-controls="collapseGeneral"
                            >
                              UMOOMI
                              <i className="material-icons">
                                keyboard_arrow_down
                              </i>
                            </a>
                          </h5>
                        </div>
                        <div
                          id="collapseGeneral"
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby="headingGeneral"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            {this.state.general === null ? (
                              <div className="text-center">
                                <h2>No Report found</h2>
                              </div>
                            ) : (
                              <div>
                                <table className="table">
                                  <thead className=" text-primary">
                                    <tr>
                                      <th>ID</th>
                                      <th>Field</th>
                                      <th>Response</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Submitted By</td>
                                      <td>{this.state.general.submitted_by}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>Jummat</td>
                                      <td>{this.state.general.jummat ? "Yes" : "No"}</td>
                                    </tr>
                                    <tr>
                                      <td>3</td>
                                      <td> Eid</td>
                                      <td>{this.state.general.eid ? "Yes" : "No"}</td>
                                    </tr>
                                    <tr>
                                      <td>4</td>
                                      <td> Ijtema</td>
                                      <td>{this.state.general.ijtema ? "Yes" : "No"}</td>
                                    </tr>

                                    <tr>
                                      <td>5</td>
                                      <td> Jalsa</td>
                                      <td> {this.state.general.jalsa ? "Yes" : "No"}</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td> Others</td>
                                      <td> {this.state.general.other ? "Yes" : "No"}</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>
                                        {" "}
                                        Was separate report of the department
                                        sent?
                                      </td>
                                      <td> {this.state.general.report_sent ? "Yes" : "No"}</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>No of khuddam on special squad</td>
                                      <td>
                                        {" "}
                                        {this.state.general.special_squad}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td> No of security training held</td>
                                      <td>{this.state.general.training}</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>No of khuddam in attendance</td>
                                      <td> {this.state.general.attendance}</td>
                                    </tr>

                                    <tr>
                                      <td>11</td>
                                      <td>No of khuddam who can drive</td>
                                      <td> {this.state.general.driver}</td>
                                    </tr>

                                    <tr>
                                      <td>12</td>
                                      <td>
                                        Is your Qaidat registered with the NYCN?
                                      </td>
                                      <td> {this.state.general.nycn1}</td>
                                    </tr>

                                    <tr>
                                      <td>13</td>
                                      <td>
                                        Attendance at regular NYCN meetings
                                      </td>
                                      <td> {this.state.general.nycn2}</td>
                                    </tr>

                                    {/*<tr>*/}
                                    {/*  <td>14</td>*/}
                                    {/*  <td>Nikkah</td>*/}
                                    {/*  <td> {this.state.general.nycn2}</td>*/}
                                    {/*</tr>*/}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    );
  }
}

SubmitedReports.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn
});

export default connect(mapStateToProps, { createUser, logOutUser })(
  SubmitedReports
);
